import { apiFetch, httpError } from '../services/apiFetch';

const API_URL = import.meta.env.VITE_API_URL;

export async function fetchDashboardSummary() {
    const res = await apiFetch(`${API_URL}/api/Dashboard/GetSummary`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch dashboard summary');
    return res.json();
}

// Worker-friendly summary — open to any role, but each list is scoped
// to the current user's own captures + their assigned jobs. Returns
// { assignedJobsCount, attention[], recentReceipts[] }.
export async function fetchWorkerDashboardSummary() {
    const res = await apiFetch(`${API_URL}/api/Dashboard/GetWorkerSummary`, { method: 'GET' });
    if (!res.ok) throw await httpError(res, 'Failed to fetch worker dashboard');
    return res.json();
}
